import script from "./BaseActionMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseActionMenu.vue?vue&type=script&setup=true&lang=ts"

import "./BaseActionMenu.vue?vue&type=style&index=0&id=bbbc7122&lang=sass&scoped=true"
import "./BaseActionMenu.vue?vue&type=style&index=1&id=bbbc7122&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bbbc7122"]])

export default __exports__
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPopupProxy,QSlideTransition,QDialog});qInstall(script, 'directives', {ClosePopup});
